module.exports = __webpack_public_path__ + "static/media/cl-1.57bb6ffe.jpg";